const axios = require("axios");

const axiosInstanceWeb = axios.create({
    baseURL: "/",
    timeout: 10000,
});

axiosInstanceWeb.interceptors.request.use(
    function (config) {
        $(".aino-loading").show();
        return config;
    },
    function (error) {
        $(".aino-loading").hide();
        return Promise.reject(error);
    }
);

// Add a response interceptor
axiosInstanceWeb.interceptors.response.use(
    function (response) {
        $(".aino-loading").hide();
        return response;
    },
    function (error) {
        $(".aino-loading").hide();
        return Promise.reject(error?.response);
    }
);

module.exports = axiosInstanceWeb;
